import DisplayAdvertising from '@propertypal/web-ui/src/products/DisplayAdvertising';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Developers Display Advertising - PropertyPal',
  description: 'Build Your Brand And Extend Your Reach To An Audience Very Specific To You.',
  url: `/products/developers/display-advertising`,
};

const DeveloperDisplayAdvertising = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <DisplayAdvertising />
      <ProductsContact reason="Developers Display Advertising" />
    </>
  );
};

export default DeveloperDisplayAdvertising;
